import { getData } from '../utils/data.js';
export const OperationStatus = {
    Normal: 'NORMAL',
    Abnormal: 'ABNORMAL',
};
export const SimStatus = {
    Ready: 'ready',
    Used: 'used',
    Paused: 'paused',
    Terminated: 'terminated',
    None: 'none',
};
export const DeviceStatus = {
    Active: 'active',
    Inactive: 'inactive',
};
export const deviceConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(d) {
        return d;
    },
};
export const IsTrappingStatus = {
    Trapping: 'trapping',
    NotTrapping: 'notTrapping',
};
//# sourceMappingURL=device.js.map